import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00f35f0c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collection-block-owner mt-1 p-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"0.8125rem","line-height":"1.2"},
  class: "fas fa-user"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IsOwnedByUser = _resolveComponent("IsOwnedByUser")!
  const _component_IconText = _resolveComponent("IconText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_IconText, { dark: _ctx.darkIcon }, {
      icon: _withCtx(() => [
        _hoisted_2
      ]),
      text: _withCtx(() => [
        _createVNode(_component_IsOwnedByUser, {
          ownerIri: _ctx.collection.owner
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("collection.my-collection")), 1)
          ]),
          isNotOwned: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.collection.ownerFullName ?? _ctx.$t("collection.unknown-owner")), 1)
          ]),
          _: 1
        }, 8, ["ownerIri"])
      ]),
      _: 1
    }, 8, ["dark"])
  ]))
}